import { ChangeDetectionStrategy, Component, inject, Input, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { NgInject } from '@df/ng/ng-inject';
import { PriceService } from '@df/ui/price/price.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsProductKlarnaMsg {
    export const ID = 'product-klarna-msg-block';

    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export interface IBlockDataContent {
        hidden?: boolean;
        buttonLink?: string;
        buttonText?: string;
    }
}

@ICmsComponent<ProductViewKlarnaMsgBlockComponent>({
    id: NCmsProductKlarnaMsg.ID,
    block: {
        url: NCmsProductKlarnaMsg.ID
    },
    name: 'Klarna Message',
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'hidden',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide',
            default: false,
            labels: { true: 'Hidden', false: 'Visible' }
        },
        <NICmsContentField.IField>{
            key: 'buttonLink',
            type: NICmsContentField.EFieldType.text,
            title: 'Button Link'
        },
        <NICmsContentField.IField>{
            key: 'buttonText',
            type: NICmsContentField.EFieldType.text,
            title: 'Button Text'
        }
    ],
    onDemandOnly: true
})
@Component({
    selector: 'product-view-klarna-msg',
    templateUrl: './product-view-klarna-msg.html',
    standalone: true,
    imports: [ImageModule, TranslationModule, RouterLink, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewKlarnaMsgBlockComponent extends UiComponent {
    @Input({
        required: true
    })
    product!: Product<IProductDataV3>;

    private priceService = inject(PriceService);

    // its required to trigger validation
    @ICmsContent({
        type: 'blockContent'
    })
    content!: NCmsProductKlarnaMsg.IBlockDataContent;

    get price(): string {
        return this.priceService.toPlainString(this.product.price / 3) || '';
    }

    override ngOnInit(): void {
        this.subscriptions.add(
            (this as NICmsContentComponent.IComponent).iCmsValidation$.subscribe(event => {
                if (event) {
                    if (!this.product?.data) {
                        event.error = {
                            level: 'info',
                            copy: 'Missing context product.'
                        };
                    }
                    if (this.content?.hidden) {
                        event.error = {
                            level: 'info',
                            copy: 'The component is hidden.'
                        };
                    }
                }
            })
        );
        super.ngOnInit();
    }

    override ngOnChanges(changes: SimpleChanges): void {
        // force revalidation on product change
        if (this.initiated && changes['product']) {
            (this as NICmsContentComponent.IComponent).iCmsValidation$?.next();
        }
        super.ngOnChanges(changes);
    }
}
